/*
 * fn: getRecAlternates
 *
 * Gets alternate rec objects from a given card and card partner's original and flavor cardRef
 *
 */
import { type CardRefType, type CardType } from '@/defs/card'
import { type RecType } from '@/defs/rec'
import { stripProps } from '@/utils/commonUtil'

import { buildRec } from './buildRec'
import { isRecEqual } from './isRecEqual'

type Props = {
  card: CardType
  cardPartner?: CardType
  rec: RecType
}

export const getRecAlternates = ({ card, cardPartner, rec }: Props) => {
  const recBase = stripProps(rec, ['onlyBack', 'onlyFront', 'onlyPartner', 'reverse'])
  const recNormalized = buildRec(recBase)

  const cardRef: CardRefType = { cardId: recBase.cardId, name: recBase.name }
  const partnerCardRef = recBase.partnerRef

  const originalRec =
    card.originalCardRef || cardPartner?.originalCardRef
      ? buildRec({
          ...recBase,
          ...(card.originalCardRef || cardRef),
          partnerRef: cardPartner?.originalCardRef || partnerCardRef,
        })
      : undefined

  const cardRefs = [cardRef, ...(card.flavorCardRefs || [])]
  const partnerCardRefs = [...(partnerCardRef ? [partnerCardRef] : []), ...(cardPartner?.flavorCardRefs || [])]

  const flavorRecs = (
    partnerCardRefs.length
      ? cardRefs.flatMap((cardRef) =>
          partnerCardRefs.map((partnerRef) => buildRec({ ...recBase, ...cardRef, partnerRef })),
        )
      : cardRefs.map((cardRef) => buildRec({ ...recBase, ...cardRef }))
  ).filter((flavorRec) => !isRecEqual(flavorRec, recNormalized))

  return {
    flavorRecs: flavorRecs.length ? flavorRecs : undefined,
    originalRec: originalRec && !isRecEqual(originalRec, recNormalized) ? originalRec : undefined,
  }
}
